import Table from '../../shared/components/table/Table';
import { ProjectStatus } from '../../../domain/projectStatus/projectStatus';
import { ViewDetails } from '../../shared/components/ViewDetails';

interface Props {
    data: ProjectStatus[];
    onSortingChange?: (columnName: string, sortOrder: 'asc' | 'desc') => void;
    sortedBy?: string | null;
    ascending?: boolean | null;
}

export default function CustomerTable({
    data: projectStatus,
    onSortingChange,
    sortedBy,
    ascending,
}: Props) {
    const triggerSortingChange = (columnName: string, sortOrder: 'asc' | 'desc') => {
        if (onSortingChange) onSortingChange(columnName, sortOrder);
    };

    return (
        <Table
            sortedBy={sortedBy}
            ascending={ascending}
            onSortingChange={triggerSortingChange}
            columns={[
                {
                    isSortable: true,
                    name: 'color',
                    title: 'Color',
                },
                {
                    isSortable: true,
                    name: 'name',
                    title: 'Nombre',
                },
                {
                    isSortable: true,
                    name: 'description',
                    title: 'Descripción',
                },
                { isSortable: false, name: 'Actions', title: '' },
            ]}
        >
            {projectStatus.map((projectState) => (
                <tr key={projectState.id}>
                    <td>
                        <div
                            style={{
                                width: '15px',
                                height: '15px',
                                borderRadius: '50%',
                                backgroundColor: projectState.color,
                                marginLeft: '10px',
                            }}
                        ></div>
                    </td>
                    <td>{projectState.name}</td>
                    <td>{projectState.description}</td>
                    <td>
                        <ViewDetails
                            href={
                                '/project-status/update-project-status/' +
                                projectState.id
                            }
                        />
                    </td>
                </tr>
            ))}
        </Table>
    );
}
